require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-online-banking-maintenance-coming-alert-9-12-24.json") })
        }
      }, "path---es-articles-online-banking-maintenance-coming-alert-9-12-24");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-online-banking-maintenance-coming-alert-9-12-24!./.cache/json/es-articles-online-banking-maintenance-coming-alert-9-12-24.json
// module id = 2228
// module chunks = 231608221292675